import { useFacilitySearch } from '@/hooks/useFacilitySearch'

import {
  useDevicesWithFacilitiesQuery,
  useFacilityFloorOptionsQuery,
  useManualIncidentCategoriesQuery,
} from '@/graphql/generated/hooks'
import {
  DeviceOrderField,
  DeviceType,
  OrderDirection,
} from '@/graphql/generated/schemas'

interface UseIncidentModalBodyIProps {
  facilityId?: string
  floorId?: string
  facilityName?: string
}

export const useIncidentCreationData = ({
  facilityId,
  facilityName,
  floorId,
}: UseIncidentModalBodyIProps) => {
  const hasFacilityId = Boolean(facilityId)
  const hasFloorId = Boolean(floorId)

  const {
    facilitiesData,
    isFacilitiesLoading,
    isError: isFacilitiesError,
  } = useFacilitySearch({
    searchQuery: facilityName,
    skip: hasFacilityId || hasFloorId,
  })
  const { data: floorsData, loading: isFloorsLoading } =
    useFacilityFloorOptionsQuery({
      variables: {
        id: facilityId,
      },
      fetchPolicy: 'network-only',
      skip: !hasFacilityId,
    })
  const { data: devicesData } = useDevicesWithFacilitiesQuery({
    fetchPolicy: 'network-only',
    variables: {
      filter: {
        facilityIdIn: [facilityId],
        floorIdIn: [floorId],
        typeNot: DeviceType.Checkpoint,
      },
      orderBy: [
        {
          direction: OrderDirection.Asc,
          field: DeviceOrderField.Name,
        },
      ],
    },
    skip: !hasFacilityId || !hasFloorId,
  })
  const { data: categoriesData } = useManualIncidentCategoriesQuery({
    nextFetchPolicy: 'network-only',
    errorPolicy: 'all',
  })

  return {
    isFacilitiesLoading,
    isFacilitiesError,
    isFloorsLoading,
    facilitiesData,
    floorsData,
    devicesData,
    categoriesData,
  }
}
